module.exports = function cleanDeclartion(node, item, list) {
    if (node.value.sequence.isEmpty()) {
        list.remove(item);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/csso/lib/compressor/clean/Declaration.js
// module id = 2514
// module chunks = 0